import config from "../../config";
import { statusHandeling } from "../../statusHandeling";

function authHeader() {
  let user = JSON.parse(localStorage.getItem("user"));
  if (user) {
    if (user.key) {
      return { Authorization: "Token  " + user.key };
    } else {
      return {};
    }
  } else {
    return {};
  }
}


const getMetricsList = async () => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(config.apiGateway.URL + "/data-analytics/trackable-actions/templates/", {
    method: "GET",
    headers: myHeaders,
  });
  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };
  return res;
};

const getRewardTypesAndPeriods = async () => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(config.apiGateway.URL + "/data-analytics/achievement-rule/choices/", {
    method: "GET",
    headers: myHeaders,
  });
  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };
  return res;
};


const getOfficeUsers = async () => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(config.apiGateway.URL + "/clinics/office-users/?office_id=" + localStorage.getItem("selectedOffice"), {
    method: "GET",
    headers: myHeaders,
  });
  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };
  return res;
};

// { "office_id": "1", "active_targets": [{
//   "rule_name": "rule1", "users_count": 1, "actions": [{ "action_name": "tp", "progress": 3, "target": 10 }]     
// }]  }
const getActiveTargetsList = async () => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(config.apiGateway.URL + "/data-analytics/active-target-detail/?office_id=" + localStorage.getItem("selectedOffice"), {
    method: "GET",
    headers: myHeaders,
  });
  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };
  return res;
};

// { "office_id": "1", "current_month": { "active_targets_count": 1, "completed_this_month": 0 }, "reward_accumulation_all_time": {"badge": 0, "points": 0, "monetary": 0, "recognition": 0 } }
const getAchievementSummary = async () => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(config.apiGateway.URL + "/data-analytics/achievement-summary/?office_id=" + localStorage.getItem("selectedOffice"), {
    method: "GET",
    headers: myHeaders,
  });
  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };
  return res;
};

const getLeaderboards = async (timeRange, rewardType) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(`${config.apiGateway.URL}/data-analytics/leaderboard-summary/?office_id=${localStorage.getItem("selectedOffice")}&time_range=${timeRange}&reward_type=${rewardType}`, {
    method: "GET",
    headers: myHeaders,
  });
  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };
  return res;
};

const getStaffProgressData = async () => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(`${config.apiGateway.URL}/data-analytics/reward-overview/?office_id=${localStorage.getItem("selectedOffice")}`, {
    method: "GET",
    headers: myHeaders,
  });
  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };
  return res;
};



// {
//   "name": "string",
//   "description": "string",
//   "reward_type": "badge",
//   "reward_amount": "string",
//   "period": "daily",
//   "start_date": "2026-02-16T08:32:20.249Z",
//   "end_date": "2026-02-16T08:32:20.249Z",
//   "branch": "1", (This is office_id)
//   "user_ids": [  1 ],
//   "actions": [ { "id": 1, "target": 10 } ]
// }
const createTarget = async (data) => {
  // const { name, patient, tooth_from, treatment_procedure_data } = data;

  const myHeaders = {
    "Content-Type": "application/json",
    ...authHeader(), // Assuming this is a custom authorization header function
  };

  // const stringifiedFields = JSON.stringify({
  //   name,
  //   patient,
  //   tooth_from,
  //   treatment_procedure_data,
  // });
  // const requestBody = JSON.parse(stringifiedFields);

  const response = await fetch(config.apiGateway.URL + "/data-analytics/achievement-rules/", {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(data),
  });

  const json = await response.json();
  return {
    json: json,
    status: response.status,
    message: "Success",
  };
};

// {
//   "name": "string",
//   "description": "string",
//   "reward_type": "badge",
//   "reward_amount": "string",
//   "period": "daily",
//   "start_date": "2026-02-16T08:32:20.249Z",
//   "end_date": "2026-02-16T08:32:20.249Z",
//   "branch": "1",
//   "user_ids": [  1 ],
//   "actions": [ { "id": 1, "target": 10 } ]
// }
const updateTarget = async (ruleId, data) => {
  // const { description, priority, name, estimated_cost, insurance_coverage, tooth_from, discount } = data;
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  // const stringifiedFields = JSON.stringify({
  //   description,
  //   priority,
  //   name,
  //   estimated_cost,
  //   insurance_coverage,
  //   tooth_from,
  //   discount,
  // });

  // const requestBody = JSON.parse(stringifiedFields);
  // requestBody.procedure = priority;
  const req = new Request(`${config.apiGateway.URL}/data-analytics/achievement-rules/${ruleId}/`, {
    body: JSON.stringify(data),
    method: "PATCH",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const removeTaget = async (ruleId) => {
  const myHeaders = Object.assign(authHeader());
  var url = "";
  url = config.apiGateway.URL + "/data-analytics/delete-achievement-rule/" + ruleId + "/" + "?office_id=" + localStorage.getItem("selectedOffice");

  const req = new Request(url, {
    method: "DELETE",
    headers: myHeaders,
  });

  const response = await fetch(req);

  if (response.status > 250) {
    const json = await response.json();
    const res = {
      json: json,
      status: response.status,
      message: response.message,
    };

    statusHandeling.statusCodeHandeling(res.status);
    return res;
  } else {
    const res = {
      json: { message: "succssfull" },
      status: 204,
      message: "Treatment plan deleted successfully",
    };

    statusHandeling.statusCodeHandeling(res.status);
    return res;
  }
};

export const targetsController = {
  getMetricsList,
  getOfficeUsers,
  getRewardTypesAndPeriods,
  getActiveTargetsList,
  getAchievementSummary,
  getLeaderboards,
  getStaffProgressData,

  //POST
  createTarget,
  updateTarget,

  //DELETE
  removeTaget
}
